import { render } from "./ChangePasswordPopup.vue?vue&type=template&id=0442bd84"
import script from "./ChangePasswordPopup.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__